import type { ComponentProps } from "react"
import { cn } from "@/utilities"

const ORDER_STATUS_LABELS: Record<string, string> = {
  cancelled: "Cancelado",
  completed: "Concluído",
  failed: "Falhou",
  "on-hold": "Em espera",
  pending: "Pendente",
  processing: "Processando",
  refunded: "Reembolsado",
}

const ORDER_STATUS_COLORS: Record<string, string> = {
  cancelled: "bg-red-50 text-red-600",
  completed: "bg-green-50 text-green-600",
  failed: "bg-red-50 text-red-600",
  "on-hold": "bg-orange-50 text-orange-600",
  pending: "bg-yellow-50 text-yellow-600",
  processing: "bg-blue-50 text-blue-600",
  refunded: "bg-purple-50 text-purple-600",
}

function formatOrderDate(value: string): string {
  const date = new Date(value)

  if (Number.isNaN(date.getTime())) {
    return value || "-"
  }

  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date)
}

function toOrderStatusLabel(status: string): string {
  return ORDER_STATUS_LABELS[status] ?? status
}

interface OrderHeaderProps extends ComponentProps<"div"> {
  orderNumber: string
  dateCreated: string
  status: string
}

export function OrderHeader({
  orderNumber,
  dateCreated,
  status,
  className,
  ...props
}: OrderHeaderProps) {
  const statusLabel = toOrderStatusLabel(status)
  const formattedDate = formatOrderDate(dateCreated)
  const statusColor = ORDER_STATUS_COLORS[status] ?? "bg-muted text-foreground"

  return (
    <div className={cn("space-y-2", className)} {...props}>
      <p className='text-base text-muted-foreground leading-7'>
        Pedido{" "}
        <mark className='bg-transparent font-semibold text-foreground'>
          {orderNumber}
        </mark>{" "}
        foi feito em{" "}
        <mark className='bg-transparent font-semibold text-foreground'>
          {formattedDate}
        </mark>{" "}
        e está{" "}
        <mark
          className={cn(
            "inline-block rounded-md px-2 py-0.5 font-semibold text-sm",
            statusColor
          )}
        >
          {statusLabel}
        </mark>
        .
      </p>
    </div>
  )
}
